var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.assetUrl,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    isQmod = companyVars.isQmod,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

var captchaIDs = {};

// The footer form lives in a display:none fancybox. Rendering hCaptcha while
// that container is hidden creates a position:fixed viewport iframe that sits
// over the submit button. Render only once the widget is on screen.
function renderHcaptchaElement(el) {
    if (!el || el.getAttribute('data-hcaptcha-rendered')) {
        return;
    }
    if (el.offsetParent === null) {
        return;
    }
    var form = jq(el).closest('form');
    if (!form.length || !form[0].id) {
        return;
    }
    window.captchaIDs[form[0].id] = hcaptcha.render(el.id, {
        "sitekey" : window.hCaptchaSiteKey,
        "size": "invisible",
        "callback": function (token) {
            // hCaptcha may already have put an h-captcha-response field in the
            // widget. Reuse whichever field exists and only create one when
            // none does, so retries never stack duplicate inputs.
            var field = form.find('[name="h-captcha-response"]').first();
            if (!field.length) {
                field = jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response'
                }).appendTo(form);
            }
            field.val(token);
            form.submit();
        }
    });
    el.setAttribute('data-hcaptcha-rendered', 'true');
}

// Forms the visitor submitted before the hCaptcha script finished loading.
// They are resumed from hCaptchaOnLoad instead of posting without a captcha.
var pendingCaptchaSubmits = {};

function showCaptchaLoadingNotice(form) {
    jq('.captcha-loading-notice').remove();
    jq('<label>', {
        'class': 'static-error error captcha-loading-notice',
        text: window.companyVars.hCaptchaLoadingMessage
    }).insertAfter(form.find('.h-captcha').first());
}

function hCaptchaOnLoad () {
    jq('.h-captcha').each(function () {
        renderHcaptchaElement(this);
    });
    jq('.captcha-loading-notice').remove();
    Object.keys(pendingCaptchaSubmits).forEach(function (id) {
        if (window.captchaIDs[id] !== undefined) {
            hcaptcha.execute(window.captchaIDs[id]);
        }
    });
    pendingCaptchaSubmits = {};
}

// Google Analytics
if (document.getElementById("analyticsOptions")) {
    var analyticsOptions = JSON.parse(document.getElementById("analyticsOptions").innerText);
    (function (i,s,o,g,r,a,m){i["GoogleAnalyticsObject"]=r;i[r]=i[r]||function (){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,"script","https://www.google-analytics.com/analytics.js","ga");
    
    ga("create", analyticsOptions.gaId, analyticsOptions.domain);
    
    (function () {
        var opts = {};
        var prefix = "/investors";
        if (location.hostname.indexOf("stockpr.com") === -1) {
            opts.cookiePath = location.pathname.substring(0, location.pathname.indexOf("/", 1) + 1)
            opts.page = prefix + location.pathname.substring(location.pathname.indexOf("/", 1));
        } else if (location.hostname.match(/^ir\./)) {
            opts.page = prefix + location.pathname;
        }
        ga("send", "pageview", opts);
    })();
    /**
    * Function that tracks a click on an outbound link in Analytics.
    * This function takes a valid URL string as an argument, and uses that URL string
    * as the event label. Setting the transport method to 'beacon' lets the hit be sent
    * using 'navigator.sendBeacon' in browser that support it.
    */
    var trackOutboundLink = function (url, category) {
        category = category || "outbound";
        ga("send", "event", category, "click", url, {
            "transport": "beacon"
        });
    }
    
    window.addEventListener("load", function () {
        // Add outbound link tracking in GA
        jq("a").not(".fancybox").each(function (){
            var href = jq(this).attr("href");
            if (typeof href === "undefined") return;
            if (href.indexOf("http") >= 0 &&
                (href.indexOf(website_base_url) < 0 && 
                    href.indexOf(ir_base_url) < 0 && 
                    href.indexOf("eqcdn") < 0 && 
                    href.indexOf("amazonaws") < 0
               )
           ) {
                jq(this).click(function (e) {
                    trackOutboundLink('"' + href + '"');
                });
            } else {
                // It's not an outbound link, but if it's a link to a file, we want to track that.
                if (href.match(/(\.pdf|\.jpg|\.png|\.gif|\.ppt|\.jpeg|\.mp3|\.mp4|\.wav|\.docx|\.doc|\.xsl|\.cslx)/g)) {
                    jq(this).click(function (e) {
                        trackOutboundLink('"' + href + '"', "documents-and-files");
                    });
                }
            }
        });
    });
}



// Main document ready scripts
jq(document).ready(function () {
    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
    });
    addRequiredAsteriskToLabels();
    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    if (scrollMore) {
        jq(scrollMore).click(function (e) {
            e.preventDefault();
            var target = jq(this).closest(".home-hero").siblings(".module").first();
            jq("html,body").animate({
                scrollTop: target.offset().top - jq("#header").height()
            }, "slow");
        });
    }
    
    jq(".mobile-nav-trigger").click(function (){
        jq(".main-nav").css("height", "auto");
    });
    
    //Set Cursor pointer to anything with data-toggle
    jq("*[data-toggle]").css("cursor", "pointer");
    
    jq("#header.affixed").affix({
        offset:{
            top: 1
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if(divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                    svgElm = jq(this).find(".circle"),
                    percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + "%");
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind("scroll");
            }
        });
    }
    
    var subNav = jq(".sub-navigation.affixed");
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("#header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById("mobile-nav"),
    showRight = document.getElementById("showRight"),
    body = document.body;
    
    if (showRight) {
        showRight.onclick = function () {
            jq(this).toggleClass("active");
            jq("body").toggleClass("push-to-left");
            jq(menuRight).toggleClass("cbp-spmenu-open");
            disableOther("showRight");
            toggleMenuKeybind();
        };
    }
    function disableOther(button) {
        if(button !== "showRight") {
          jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq("body"),
            $body_events = $body.data("events");
            
        if ($body_events !== null && typeof($body_events.keydown) !== undefined) {
            $body.off("keydown");
        }else {
        $body.on("keydown", function (e) {
            if (e.which == 27) {
                jq(".main-nav").toggleClass("active");
                jq("body").toggleClass("push-to-left");
                jq(menuRight).toggleClass("cbp-spmenu-open");
                disableOther("showRight");
                $body.off("keydown");
            }
        });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.parent());
            },
            submitHandler: function (form) {
                var $form = jq(form);
                var widget = $form.find('.h-captcha')[0];
                // No widget on this form (login, register, reset): plain submit.
                if (!widget) {
                    form.submit();
                    return;
                }
                // The form is captcha-protected but hCaptcha is not available yet
                // (async script still loading, or blocked). Never post without it:
                // the server would reject the post and the visitor would lose
                // what they typed. Keep the form as it is and resume on load.
                var formID = form.getAttribute('id');
                if (!window.hcaptcha) {
                    pendingCaptchaSubmits[formID] = true;
                    showCaptchaLoadingNotice($form);
                    return;
                }
                renderHcaptchaElement(widget);
                var widgetID = window.captchaIDs[formID];
                if (widgetID === undefined) {
                    showCaptchaLoadingNotice($form);
                    return;
                }
                if (hcaptcha.getResponse(widgetID)) {
                    form.submit();
                } else {
                    hcaptcha.reset(widgetID);
                    hcaptcha.execute(widgetID);
                }
            }
        });
    });
    jq.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    }
    
    jq(".toggle-button").click(function () {
        jq(this).toggleClass("open");
    });
    
    jq(".fancybox").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "600",
        afterShow: function (instance, current) {
            var content = current && current.$content ? current.$content : jq('#email-popup');
            if (!window.hcaptcha) {
                return;
            }
            content.find('.h-captcha').each(function () {
                renderHcaptchaElement(this);
            });
        }
    });
    jq(".fancybox-sec-filing").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "900"
    });
    
    jq(".fancybox-bio").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "0"
    });
    
    jq(".fancybox-modal").fancybox({
        width: 970,
        autoSize: false,
        height: "auto"
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: "iframe",
        iframe : {
            css : {
                width : "80%",
                maxWidth: "1024px",
            }
        }
    });
    
    //Bootrap Select
    jq(".selectpicker").selectpicker({
        iconBase: "DIN",
        tickIcon: "no-icon",
        dropupAuto: false,
        size: 5
    });
    
    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e){
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit(); 
    });
    
    var $filterSelect = jq(".year-filter .selectpicker");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".year-filter .selectpicker").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }
});

// Quote Box
function populateQuoteBox(quote) {

    if (jq(".ir-quote-box").length > 0) {
        var quoteContainer = jq('.ir-quote-box[data-symbol="' + quote.symbol + '"]');
    } else {
        var quoteContainer = jq('.quote-box[data-symbol="' + quote.symbol + '"]');
        var home_change = true;
    }
        
    var quote_price = checkQuoteProperty(quote.last),
        quote_change = checkQuoteProperty(quote.change),
        quote_change_pct = checkQuoteProperty(quote.change_pct),
        quote_high = checkQuoteProperty(quote.high),
        quote_low = checkQuoteProperty(quote.low),
        quote_day_low = checkQuoteProperty(quote.day_low),
        quote_day_high = checkQuoteProperty(quote.day_high),
        quote_volume = quote.volume;
        // Quotemedia's volume already comes back formatted, so we do not need to custom format it
        if (quote_volume && quote.use_quotemedia !== true) {
            quote_volume = quote_volume.replace(/\,/g,'');
            quote_volume = parseInt(quote_volume,10);
            quote_volume = abbrNum(quote_volume, 2);
        }   
   

    quoteContainer.find(".time").html("<time />");
    quoteContainer.find("time").attr("datetime", quote.last_trade_time).html(quote.last_trade_time);  
    
    
    if (quote_price == "N/A") {
        quoteContainer.find(".price .value").html("N/A");
    } else {
          quoteContainer.find(".price .value").html("$" + quote_price);
    }

    if (quote.market_cap == "N/A") {
        quoteContainer.find(".market-cap .value").html("N/A");
    } else {
        quoteContainer.find(".market-cap .value").html("$" + quote.market_cap);
    }
    
     if (quote.volume == null) {
         quoteContainer.find(".volume .value").html("N/A");
     }else {
         quoteContainer.find(".volume .value").html(quote_volume);
     }

    var change = quote_change.replace(/[+|-]/g, "");

    
    quoteContainer.find(".change .value .number").html(change);
    
    if(quote_change_pct != "0.00" && quote_change_pct != "N/A" && quote_change_pct != "0") {
        quoteContainer.find(".change .value .percent").html("(" + quote_change_pct + "%)");
    }
    if (home_change) {
        quoteContainer.find(".change .home-change-value").html(change);
    }

    if (quote.change.indexOf("+") > -1 && change !== "0" && change !== "0.00") {
        quoteContainer.find(".change").addClass("up");
    } else if (quote.change.indexOf("-") > -1) {
        quoteContainer.find(".change").addClass("down");
    }
    
    if (quote.low == quote.high) {
        week = quote_low;    
    } else {
        var week = quote_low + ' - ' + quote_high;         
    }
    quoteContainer.find(".week-range .value").html(week);

    if (quote.day_low != "N/A" && quote.day_high != "N/A") {
        if (quote.day_low == quote.day_high) {
            var day = quote_day_low;
        } else {
            day = quote_day_low + " - " + quote_day_high;
        }
        quoteContainer.find(".day-range .value").html(day);
    } else {
        quoteContainer.find(".day-range .value").html(quote.last)
    }
    
    jq(".jsrange").jsRange({
        dayLow: quote_day_low,
        dayHigh: quote_day_high,
        yearLow: quote_low,
        yearHigh: quote_high
    });

}

// SEC Filings expand
jq(".spr-expandable").hide();
jq(".spr-toggle-expandable").click(function () {
	jq(this).next(".spr-expandable").toggle("blind");
});

// Equal Heights
jq(window).on("load", function () {
    checkWidth();
});

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        var currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

function checkQuoteProperty(value) {
    return (value != "N/A") ? parseFloat(value).toFixed(2) : value;
}

function abbrNum(number, decPlaces) {
    var orig = number;
    var dec = decPlaces;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    var abbrev = ["K", "M", "B", "T"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if ((number == 1000) && (i < abbrev.length - 1)) {
                number = 1;
                i++;
            }

            // console.log(number);
            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    //console.log('abbrNum('+ orig + ', ' + dec + ') = ' + number);
    return number;
}

// Add commas to numbers
jq.fn.digits = function () {
    return this.each(function () {
        jq(this).text(jq(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    });
};

//Smooth scroll to
function goToByScroll(id) {
    jq("html,body").animate({
        scrollTop: jq(id).offset().top
    }, "slow");
}
jq(".smooth").click(function () {
    goToByScroll(jq(this).attr("href"));
    return false;
});

//Check Width
var resizeTimer;
jq(window).resize(function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWidth, 250);
});

function checkWidth() {
    if (jq(window).width() > 767) {
        jq(".js-same-height, .js-same-height-row").each(function () {
            jq(this).addClass("active");
        });
        sameHeight();
    } else {
        jq(".js-same-height, .js-same-height-row").each(function () {
            jq(this).removeClass("active");
        });
        jq(".js-same-height,.js-same-height-row .js-height").css("min-height", "").css("height", "");
    }
    if (jq(window).width() < 769) {
        jq(".fancybox").each(function () {
            jq(this).addClass("fancybox-holder").removeClass("fancybox");
        });
        jq(".thickbox").each(function () {
            jq(this).addClass("thickbox-holder").removeClass("thickbox");
        });
    } else {
        jq(".fancybox-holder").each(function () {
            jq(this).addClass("fancybox").removeClass("fancybox-holder");
        });
        jq(".thickbox-holder").each(function () {
            jq(this).addClass("thickbox").removeClass("thickbox-holder");
        });
    }

}

//Match Height With Delay for Qmod. Add class same-height to elements
if (isQmod) {    
    var matchHeightInterval;

    matchHeightInterval = setInterval(matchHeightDelay, 50);
    
    function matchHeightDelay()
    {
        if (jq(".qmod-ui-tool").length == 0) return;
        jq(".same-height").matchHeight(); 
        clearInterval(matchHeightInterval);
    }
}


// Same Height
function sameHeight() {
    jq(".js-same-height-row").each(function () {
        var $maxHeight = 0,
            $window_width = jq(window).width();
        jq(".js-same-height", this).css({
            "height": "auto",
            "min-height": 0
        });
        if ((jq(this).data("cutoff") && jq(this).data("cutoff") >= $window_width) || $window_width < 768) {
            return false;
        }
        jq(".js-same-height", this).each(function () {
            if (jq(this).outerHeight() > $maxHeight) {
                $maxHeight = jq(this).outerHeight();
            }
        }).css("min-height", $maxHeight);
        jq(".js-height", this).css({
            "height": $maxHeight,
            "min-height": 0
        });
    });
}

// Fixes XBRL Filing Close Button click event being unbound by an early call to tb_remove
jq(document).ajaxComplete(function () {
    jq("#TB_closeAjaxWindow #TB_closeWindowButton").on("mousedown", function () {
        tb_remove();
    });
});

// Checkbox Groups
var update_sec_checkboxes = function () {
    if (jq("#ir-sec-all").is(":checked")) {
        jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
    } else {
        jq(".ir-sec-sub").prop("disabled", false).prop("checked", false);
    }
}
jq("#ir-sec-all").change(update_sec_checkboxes);
if (jq("#ir-sec-all").is(":checked")) {
    jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
}

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                  var point = jq(this).find(".point");
                  jq(this).css("height", point.outerHeight()/1.2);
                });
        }
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}

// Crisis Messaging
var crisisMessage = jq(".crisis-messaging");
var crisisMessageCookieName = "eqMajorAnnouncement";
if (crisisMessage.length) {
    jq('.crisis-messaging a[href="#"]').click(function (e){
        e.preventDefault();
        crisisMessage.addClass("hide");
    });
    var crisisMessageTimestamp = crisisMessage.data("timestamp");
    console.log(crisisMessageTimestamp);
    var crisisMessageCookie = Cookies.get(crisisMessageCookieName);
    if (crisisMessageCookie != crisisMessageTimestamp) {
        crisisMessage.removeClass("hide");
        // Expires should be set to a number of days
        Cookies.set(crisisMessageCookieName, crisisMessageTimestamp, {secure: true, domain: window.location.hostname, expires: 7 });
    }
}